import { RestApiManager } from '../../api/RestApiManager';
import { recommendationTypeParam, RoutesPath } from '../../routes/index';
import {
    audiences,
    banners,
    campaigns,
    feedFilters,
    groups,
    phrases,
    retargetings,
    usersProfile
} from '../../typings/common';
import { GridViewType } from '../../typings/grid';
import { captureException } from '../ErrorsReporting/ErrorsReporting';
// bundle scripts for RUM metrics
if (window.Ya) {
    require('../../../node_modules/@yandex-int/rum-counter/dist/bundle/implementation.min.js');
    require('../../../node_modules/@yandex-int/rum-counter/dist/bundle/onload.min.js');
    require('../../../node_modules/@yandex-int/rum-counter/dist/bundle/bem.min.js');

    if (process.env.RUM_DEBUG === '1') {
        require('../../../node_modules/@yandex-int/rum-counter/debug/blockstat.js');
    }

    // error-counter-debug для локальной отладки error-counter нужно раскомментировать строки ниже error-counter-debug
    // require('../../../node_modules/@yandex-int/error-counter/dist/interfaceOverRum.js');
    // require('../../../node_modules/@yandex-int/error-counter/dist/implementation.js');
    // require('../../../node_modules/@yandex-int/error-counter/dist/filters.js');
    // require('../../../node_modules/@yandex-int/error-counter/dist/logError.js');
    // require('../../../node_modules/@yandex-int/error-counter/dist/logAjaxError.js');
}

// RUM - счетчик, предназначенный для сбора и отправки тайм-сетов на RJM расчеты.
// Результаты сборов можно посмотреть в логах Hahn, или же в ежедневно собираемом датасете

export enum DeviceType {
    mobile = 'mobile',
    desktop = 'desktop'
}

export enum rumCounters {
    campaignsFirst = 'campaignsFirst',
    campaignsFirst10 = 'campaignsFirst10',
    campaignsFirst50 = 'campaignsFirst50',
    campaignsFirst100 = 'campaignsFirst100',
    campaignsFirst500 = 'campaignsFirst500',
    campaignsFirst1000 = 'campaignsFirst1000',
    campaignsFirst10000 = 'campaignsFirst10000',
    groupsFirst = 'groupsFirst',
    groupsFirst10 = 'groupsFirst10',
    groupsFirst50 = 'groupsFirst50',
    groupsFirst100 = 'groupsFirst100',
    groupsFirst500 = 'groupsFirst500',
    groupsFirst1000 = 'groupsFirst1000',
    groupsFirst10000 = 'groupsFirst10000',
    bannersFirst = 'bannersFirst',
    bannersFirst10 = 'bannersFirst10',
    bannersFirst50 = 'bannersFirst50',
    bannersFirst100 = 'bannersFirst100',
    bannersFirst500 = 'bannersFirst500',
    bannersFirst1000 = 'bannersFirst1000',
    bannersFirst10000 = 'bannersFirst10000',
    phrasesFirst = 'phrasesFirst',
    phrasesFirst10 = 'phrasesFirst10',
    phrasesFirst50 = 'phrasesFirst50',
    phrasesFirst100 = 'phrasesFirst100',
    phrasesFirst500 = 'phrasesFirst500',
    phrasesFirst1000 = 'phrasesFirst1000',
    phrasesFirst10000 = 'phrasesFirst10000',
    feedFiltersFirst = 'feedFiltersFirst',
    feedFiltersFirst10 = 'feedFiltersFirst10',
    feedFiltersFirst50 = 'feedFiltersFirst50',
    feedFiltersFirst100 = 'feedFiltersFirst100',
    feedFiltersFirst500 = 'feedFiltersFirst500',
    feedFiltersFirst1000 = 'feedFiltersFirst1000',
    feedFiltersFirst10000 = 'feedFiltersFirst10000',
    audiencesFirst = 'audiencesFirst',
    audiencesFirst10 = 'audiencesFirst10',
    audiencesFirst50 = 'audiencesFirst50',
    audiencesFirst100 = 'audiencesFirst100',
    audiencesFirst500 = 'audiencesFirst10',
    audiencesFirst1000 = 'audiencesFirst1000',
    audiencesFirst10000 = 'audiencesFirst10000',
    targetingsFirst = 'targetingsFirst',
    targetingsFirst10 = 'targetingsFirst10',
    targetingsFirst50 = 'targetingsFirst50',
    targetingsFirst100 = 'targetingsFirst100',
    targetingsFirst500 = 'targetingsFirst500',
    targetingsFirst1000 = 'targetingsFirst1000',
    targetingsFirst10000 = 'targetingsFirst10000',
    usersProfileFirst = 'usersProfileFirst',
    usersProfileFirst10 = 'usersProfileFirst10',
    usersProfileFirst50 = 'usersProfileFirst50',
    usersProfileFirst100 = 'usersProfileFirst100',
    usersProfileFirst500 = 'usersProfileFirst500',
    usersProfileFirst1000 = 'usersProfileFirst1000',
    usersProfileFirst10000 = 'usersProfileFirst10000',
    bannersEditFirst = 'bannersEditFirst',
    bannersEditCpmFirst = 'bannersEditCpmFirst',
    bannersEditCpcFirst = 'bannersEditCpcFirst',
    bannersEditFirst10 = 'bannersEditFirst10',
    bannersEditFirst50 = 'bannersEditFirst50',
    bannersEditFirst100 = 'bannersEditFirst100',
    bannersEditFirst500 = 'bannersEditFirst500',
    bannersEditFirst1000 = 'bannersEditFirst1000',
    groupsEditCpmFirst = 'groupsEditCpmFirst',
    groupsEditCpcFirst = 'groupsEditCpcFirst',
    groupsEditFirst = 'groupsEditFirst',
    groupsEditFirst10 = 'groupsEditFirst10',
    groupsEditFirst50 = 'groupsEditFirst50',
    groupsEditFirst100 = 'groupsEditFirst100',
    groupsEditFirst500 = 'groupsEditFirst500',
    groupsEditFirst1000 = 'groupsEditFirst1000',
    unknownFisrt = 'unknownFisrt',
    backendGetGroupsMassActionsCount = 'backendGetGroupsMassActionsCount',
    backendCampaigns = 'backendCampaigns',
    backendGroups = 'backendGroups',
    backendBanners = 'backendBanners',
    backendPhrase = 'backendPhrase',
    backendTargetings = 'backendTargetings',
    backendUsersProfile = 'backendUsersProfile',
    backendUnknown = 'backendUnknown',
    clientCampaignsMapper = 'clientCampaignsMapper',
    clientGroupsMapper = 'clientGroupsMapper',
    clientBannersMapper = 'clientBannersMapper',
    clientPhraseMapper = 'clientPhraseMapper',
    clientTargetingsMapper = 'clientTargetingsMapper',
    clientUsersProfileMapper = 'clientUsersProfileMapper',
    clientMapperUnknown = 'clientUnknownMapper',
    backendSuggestCampaigns = 'backendSuggestCampaigns',
    backendSuggestGroups = 'backendSuggestGroups',
    backendSuggestBanners = 'backendSuggestBanners',
    backendSuggestPhrase = 'backendSuggestPhrase',
    backendSuggestTargetings = 'backendSuggestTargetings',
    backendSuggestUsersProfile = 'backendSuggestUsersProfile',
    backendSuggestUnknown = 'backendSuggestUnknown',
    clientSuggestCampaignsMapper = 'clientSuggetCampaignsMapper',
    clientSuggestGroupsMapper = 'clientSuggestGroupsMapper',
    clientSuggestBannersMapper = 'clientSuggestBannersMapper',
    clientSuggestPhraseMapper = 'clientSuggestPhraseMapper',
    clientSuggestTargetingsMapper = 'clientSuggestTargetingsMapper',
    clientSuggestUsersProfileMapper = 'clientSuggestUsersProfileMapper',
    clientSuggestMapperUnknown = 'clientSuggestUnknownMapper',
    backendPriceWizardBids = 'backendPriceWizardBids',
    backendPriceWizardAutoBids = 'backendPriceWizardAutoBids',
    backendSearchAndReplaceKeyWords = 'backendSearchAndReplaceKeyWords',
    backendSearchAndReplaceKeyWordsPreview = 'backendSearchAndReplaceKeyWordsPreview',
    backendUnsuspendKeywords = 'backendUnsuspendKeywords',
    backendSuspendKeywords = 'backendSuspendKeywords',
    backendUpdateKeywords = 'backendUpdateKeywords',
    backendKeywordsDelete = 'backendKeywordsDelete',
    backendAddKeywords = 'backendAddKeywords',
    backendGetBanners = 'backendGetBanners',
    clientGetBannersMapper = 'clientGetBannersMapper',
    backendAddGroupMinusKeywords = 'backendAddGroupMinusKeywords',
    backendPhraseFeaturesData = 'backendPhraseFeaturesData',
    clientPhraseFeaturesDataMapper = 'clientPhraseFeaturesDataMapper',
    backendRecommendations = 'backendRecommendation',
    backendMinusPhraseLibraryGrid = 'backendMinusPhraseLibraryGrid',
    backendBulkUpdateOrganizations = 'backendBulkUpdateOrganizations',
    clientRecommendationsRender = 'clientRecommendationsRender',
    clientGridRecommendationsDailyBudgetRender = 'clientGridRecommendationsDailyBudgetRender',
    clientGridRecommendationsRemovePagesFromBlackListRender = 'clientGridRecommendationsRemovePagesFromBlackListRender',
    clientGridRecommendationsSwitchOnAutotargetingRender = 'clientGridRecommendationsSwitchOnAutotargetingRender',
    clientGridRecommendationsDailyBudgetMapper = 'clientGridRecommendationsDailyBudgetMapper',
    clientGridRecommendationsRemovePagesFromBlackListMapper = 'clientGridRecommendationsRemovePagesFromBlackListMapper',
    clientGridRecommendationsSwitchOnAutotargetingMapper = 'clientGridRecommendationsSwitchOnAutotargetingMapper',
    backendGridRecommendationsDailyBudget = 'backendGridRecommendationsDailyBudget',
    backendGridRecommendationsRemovePagesFromBlackList = 'backendGridRecommendationsRemovePagesFromBlackList',
    backendGridRecommendationsSwitchOnAutotargeting = 'backendGridRecommendationsSwitchOnAutotargeting',
    dnaGridCampaignsRouteSubPage = 'dnaGridCampaignsRouteSubPage',
    dnaGridGroupsRouteSubPage = 'dnaGridGroupsRouteSubPage',
    dnaGridBannersRouteSubPage = 'dnaGridBannersRouteSubPage',
    dnaGridPhrasesRouteSubPage = 'dnaGridPhrasesRouteSubPage',
    dnaGridTargetingsRouteSubPage = 'dnaGridTargetingsRouteSubPage',
    dnaGridUsersProfileRouteSubPage = 'dnaGridUsersProfileRouteSubPage',
    dnaLogsRouteSubPage = 'dnaLogsRouteSubPage',
    dnaRecommendationsGridRouteSubPage = 'dnaRecommendationsGridRouteSubPage',
    dnaRecommendationsRouteSubPage = 'dnaRecommendationsRouteSubPage',
    dnaOfflineReportsRouteSubPage = 'dnaOfflineReportsRouteSubPage',
    dnaCustomersRouteSubPage = 'dnaCustomersRouteSubPage',
    dnaWelcomeRouteSubPage = 'dnaWelcomeRouteSubPage',
    dnaMobileAppsRouteSubPage = 'dnaMobileAppsRouteSubPage',
    dnaFreelancersRouteSubPage = 'dnaFreelancersRouteSubPage',
    dnaDealsRouteSubPage = 'dnaDealsRouteSubPage',
    dnaBannersEditRouteSubPage = 'dnaBannersEditRouteSubPage',
    dnaGroupsEditRouteSubPage = 'dnaGroupsEditRouteSubPage',
    dnaSPARecommendationsRender = 'dnaSPARecommendationsRender',
    dnaSPARecommendationsGridRender = 'dnaSPARecommendationsGridRender',
    dnaSPABannersEditRender = 'dnaSPABannersEditRender',
    dnaSPABannersEditCpmRender = 'dnaSPABannersEditCpmRender',
    dnaSPABannersEditCpcRender = 'dnaSPABannersEditCpcRender',
    dnaSPAGroupsEditCpmRender = 'dnaSPAGroupsEditCpmRender',
    dnaSPAGroupsEditCpcRender = 'dnaSPAGroupsEditCpcRender',
    dnaSPAGroupsEditRender = 'dnaSPAGroupsEditRender',
    dnaSPABannersEditRender10 = 'dnaSPABannersEditRender10',
    dnaSPAGroupsEditRender10 = 'dnaSPAGroupsEditRender10',
    dnaSPABannersEditRender50 = 'dnaSPABannersEditRender50',
    dnaSPAGroupsEditRender50 = 'dnaSPAGroupsEditRender50',
    dnaSPABannersEditRender100 = 'dnaSPABannersEditRender100',
    dnaSPAGroupsEditRender100 = 'dnaSPAGroupsEditRender100',
    dnaSPABannersEditRender500 = 'dnaSPABannersEditRender500',
    dnaSPAGroupsEditRender500 = 'dnaSPAGroupsEditRender500',
    dnaSPABannersEditRender1000 = 'dnaSPABannersEditRender1000',
    dnaSPAGroupsEditRender1000 = 'dnaSPAGroupsEditRender1000',
    backendCampaignRecommendations = 'backendCampaignDailyBudgetRecommendation'
}

export enum rumCountersBackendKeys {
    priceWizard = 'priceWizard',
    searchAndReplace = 'searchAndReplace'
}

export interface InterfaceEvents {
    isDataActual?: boolean;
}

export type RumCountersDictKeys = rumCounters | GridViewType;
type RumCounterDictType = Record<RumCountersDictKeys, string>;

export type RumCountersBackendKeys = GridViewType | rumCountersBackendKeys;

// https://stat.yandex-team.ru/DictionaryEditor/BlockStat
export const blockStatDict = {
    ten: 3912,
    fifty: 3913,
    hundred: 3914,
    five: 988,
    thousand: 3915,
    mass: 3668,
    users: 3585,
    spa: 3502,
    phrases: 3501,
    deals: 3496,
    freelancers: 3495,
    customers: 3493,
    reports: 3381,
    mapper: 3249,
    budget: 3248,
    get: 3234,
    suspend: 3233,
    unsuspend: 3232,
    delete: 3231,
    keywords: 3230,
    bids: 3229,
    grid: 3223,
    and: 3211,
    targetings: 3203,
    audiences: 3202,
    campaign: 3652,
    campaigns: 3201,
    dna: 3200,
    render: 3150,
    complete: 3103,
    feed: 3003,
    client: 2989,
    replace: 2898,
    edit: 2818,
    update: 2740,
    recommendations: 2671,
    daily: 2669,
    price: 2506,
    logs: 2499,
    offline: 2470,
    organizations: 1312,
    remove: 2452,
    welcome: 2429,
    data: 2368,
    backend: 2006,
    actions: 1897,
    minus: 1821,
    load: 1724,
    switch: 1387,
    count: 1385,
    groups: 1360,
    features: 1263,
    profile: 1087,
    mobile: 1006,
    items: 967,
    unknown: 836,
    suggest: 695,
    preview: 670,
    filters: 618,
    route: 593,
    apps: 498,
    view: 493,
    list: 436,
    wizard: 358,
    auto: 227,
    first: 205,
    black: 201,
    add: 160,
    banners: 159,
    direct: 155,
    search: 153,
    phrase: 61,
    ru: 28,
    on: 10,
    cpm: 3689,
    cpc: 3964
};

function getRumId(...keys: number[]): string {
    return keys.join('.');
}

const rumCountersDict: RumCounterDictType = {
    [rumCounters.campaignsFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.campaigns,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ),
    [rumCounters.campaignsFirst10]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.campaigns,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ),
    [rumCounters.campaignsFirst50]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.campaigns,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.grid,
        blockStatDict.items
    ),
    [rumCounters.campaignsFirst100]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.campaigns,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ),
    [rumCounters.campaignsFirst500]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.campaigns,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ),
    [rumCounters.campaignsFirst1000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.campaigns,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ),
    [rumCounters.campaignsFirst10000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.campaigns,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ),
    [rumCounters.groupsFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.groups,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ),
    [rumCounters.groupsEditCpmFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.cpm,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ),
    [rumCounters.groupsEditCpcFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.cpc,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ),
    [rumCounters.groupsFirst10]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.groups,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.groups.complete.ten.grid.items
    [rumCounters.groupsFirst50]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.groups,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.groups.complete.fifty.grid.items
    [rumCounters.groupsFirst100]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.groups,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.groups.complete.hundred.grid.items
    [rumCounters.groupsFirst500]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.groups,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.groups.complete.five.hundred.grid.items
    [rumCounters.groupsFirst1000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.groups,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.groups.complete.thousand.grid.items
    [rumCounters.groupsFirst10000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.groups,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.groups.complete.ten.thousand.grid.items
    [rumCounters.bannersFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.banners,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ), // dna.view.banners.first.load.render
    [rumCounters.bannersFirst10]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.banners,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.banners.complete.ten.grid.items
    [rumCounters.bannersFirst50]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.banners,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.banners.complete.fifty.grid.items
    [rumCounters.bannersFirst100]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.banners,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.banners.complete.hundred.grid.items
    [rumCounters.bannersFirst500]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.banners,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.banners.complete.five.hundred.grid.items
    [rumCounters.bannersFirst1000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.banners,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.banners.complete.thousand.grid.items
    [rumCounters.bannersFirst10000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.banners,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.banners.complete.ten.thousand.grid.items
    [rumCounters.phrasesFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.phrase,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ), // dna.view.phrase.first.load.render
    [rumCounters.phrasesFirst10]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.phrase,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.phrase.complete.ten.grid.items
    [rumCounters.phrasesFirst50]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.phrase,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.phrase.complete.fifty.grid.items
    [rumCounters.phrasesFirst100]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.phrase,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.phrase.complete.hundred.grid.items
    [rumCounters.phrasesFirst500]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.phrase,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.phrase.complete.five.hundred.grid.items
    [rumCounters.phrasesFirst1000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.phrase,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.phrase.complete.thousand.grid.items
    [rumCounters.phrasesFirst10000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.phrase,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.phrase.complete.ten.thousand.grid.items
    [rumCounters.feedFiltersFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.feed,
        blockStatDict.filters,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ), // dna.view.feed.filters.first.load.render
    [rumCounters.feedFiltersFirst10]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.feed,
        blockStatDict.filters,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.feed.filters.complete.ten.grid.items
    [rumCounters.feedFiltersFirst50]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.feed,
        blockStatDict.filters,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.feed.filters.complete.fifty.grid.items
    [rumCounters.feedFiltersFirst100]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.feed,
        blockStatDict.filters,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.feed.filters.complete.hundred.grid.items
    [rumCounters.feedFiltersFirst500]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.feed,
        blockStatDict.filters,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.feed.filters.complete.five.hundred.grid.items
    [rumCounters.feedFiltersFirst10000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.feed,
        blockStatDict.filters,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.feed.filters.complete.thousand.grid.items
    [rumCounters.feedFiltersFirst1000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.feed,
        blockStatDict.filters,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.feed.filters.complete.ten.thousand.grid.items
    [rumCounters.audiencesFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.audiences,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ), // dna.view.audiences.first.load.render
    [rumCounters.audiencesFirst10]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.audiences,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.audiences.complete.ten.grid.items
    [rumCounters.audiencesFirst50]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.audiences,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.audiences.complete.fifty.grid.items
    [rumCounters.audiencesFirst100]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.audiences,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.audiences.complete.hundred.grid.items
    [rumCounters.audiencesFirst500]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.audiences,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.audiences.complete.five.hundred.grid.items
    [rumCounters.audiencesFirst1000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.audiences,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.audiences.complete.thousand.grid.items
    [rumCounters.audiencesFirst10000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.audiences,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.audiences.complete.ten.thousand.grid.items
    [rumCounters.targetingsFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.targetings,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ), // dna.view.targetings.first.load.render
    [rumCounters.targetingsFirst10]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.targetings,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.targetings.complete.ten.grid.items
    [rumCounters.targetingsFirst50]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.targetings,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.targetings.complete.fifty.grid.items
    [rumCounters.targetingsFirst100]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.targetings,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.targetings.complete.hundred.grid.items
    [rumCounters.targetingsFirst500]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.targetings,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.targetings.complete.five.hundred.grid.items
    [rumCounters.targetingsFirst1000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.targetings,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.targetings.complete.thousand.grid.items
    [rumCounters.targetingsFirst10000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.targetings,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.targetings.complete.ten.thousand.grid.items
    [rumCounters.usersProfileFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ), // dna.view.users.profile.first.load.render
    [rumCounters.usersProfileFirst10]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.users.profile.complete.ten.grid.items
    [rumCounters.usersProfileFirst50]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.users.profile.complete.fifty.grid.items
    [rumCounters.usersProfileFirst100]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.users.profile.complete.hundred.grid.items
    [rumCounters.usersProfileFirst500]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.users.profile.complete.five.hundred.grid.items
    [rumCounters.usersProfileFirst1000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.users.profile.complete.thousand.grid.items
    [rumCounters.usersProfileFirst10000]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.ten,
        blockStatDict.grid,
        blockStatDict.items
    ), // dna.view.users.profile.complete.ten.thousand.grid.items
    [rumCounters.bannersEditFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ),
    [rumCounters.bannersEditCpmFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.cpm,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ),
    [rumCounters.bannersEditCpcFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.cpc,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ),
    [rumCounters.bannersEditFirst10]: getRumId(
        blockStatDict.dna,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.items
    ),
    [rumCounters.bannersEditFirst50]: getRumId(
        blockStatDict.dna,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.items
    ),
    [rumCounters.bannersEditFirst100]: getRumId(
        blockStatDict.dna,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.items
    ),
    [rumCounters.bannersEditFirst500]: getRumId(
        blockStatDict.dna,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.items
    ),
    [rumCounters.bannersEditFirst1000]: getRumId(
        blockStatDict.dna,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.items
    ),
    [rumCounters.groupsEditFirst]: getRumId(
        blockStatDict.dna,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ),
    [rumCounters.groupsEditFirst10]: getRumId(
        blockStatDict.dna,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.items
    ),
    [rumCounters.groupsEditFirst50]: getRumId(
        blockStatDict.dna,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.items
    ),
    [rumCounters.groupsEditFirst100]: getRumId(
        blockStatDict.dna,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.items
    ),
    [rumCounters.groupsEditFirst500]: getRumId(
        blockStatDict.dna,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.items
    ),
    [rumCounters.groupsEditFirst1000]: getRumId(
        blockStatDict.dna,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.items
    ),
    [rumCounters.unknownFisrt]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.unknown,
        blockStatDict.first,
        blockStatDict.load,
        blockStatDict.render
    ), // dna.view.unknown.first.load.render
    [rumCounters.backendCampaigns]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.campaigns,
        blockStatDict.complete
    ), // dna.backend.campaigns.complete
    [rumCounters.backendGroups]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.groups,
        blockStatDict.complete
    ), // dna.backend.groups.complete
    [rumCounters.backendBanners]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.banners,
        blockStatDict.complete
    ), // dna.backend.banners.complete
    [rumCounters.backendPhrase]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.phrase,
        blockStatDict.complete
    ), // dna.backend.phrase.complete
    [rumCounters.backendTargetings]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.targetings,
        blockStatDict.complete
    ), // dna.backend.targetings.complete
    [rumCounters.backendUsersProfile]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.complete
    ), // dna.backend.users.profile.complete
    [rumCounters.backendUnknown]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.phrase,
        blockStatDict.complete
    ), // dna.backend.unknown.complete
    [rumCounters.clientCampaignsMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.campaigns,
        blockStatDict.complete
    ), // dna.client.campaigns.complete
    [rumCounters.clientGroupsMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.groups,
        blockStatDict.complete
    ), // dna.client.groups.complete
    [rumCounters.clientBannersMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.banners,
        blockStatDict.complete
    ), // dna.client.banners.complete
    [rumCounters.clientPhraseMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.phrase,
        blockStatDict.complete
    ), // dna.client.phrase.complete
    [rumCounters.clientTargetingsMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.targetings,
        blockStatDict.complete
    ), // dna.client.targetings.complete
    [rumCounters.clientUsersProfileMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.complete
    ), // dna.client.users.profile.complete
    [rumCounters.clientMapperUnknown]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.unknown,
        blockStatDict.complete
    ), // dna.client.unknown.complete
    [rumCounters.backendSuggestCampaigns]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.campaigns,
        blockStatDict.suggest,
        blockStatDict.complete
    ), // dna.backend.campaigns.suggest.complete
    [rumCounters.backendSuggestGroups]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.groups,
        blockStatDict.suggest,
        blockStatDict.complete
    ), // dna.backend.groups.suggest.complete
    [rumCounters.backendSuggestBanners]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.banners,
        blockStatDict.suggest,
        blockStatDict.complete
    ), // dna.backend.banners.suggest.complete
    [rumCounters.backendSuggestPhrase]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.phrase,
        blockStatDict.suggest,
        blockStatDict.complete
    ), // dna.backend.phrase.suggest.complete
    [rumCounters.backendSuggestTargetings]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.targetings,
        blockStatDict.suggest,
        blockStatDict.complete
    ), // dna.backend.targetings.suggest.complete
    [rumCounters.backendSuggestUsersProfile]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.suggest,
        blockStatDict.complete
    ), // dna.backend.users.profile.suggest.complete
    [rumCounters.backendSuggestUnknown]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.unknown,
        blockStatDict.suggest,
        blockStatDict.complete
    ), // dna.backend.unknown.suggest.complete
    [rumCounters.clientSuggestCampaignsMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.campaigns,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.client.campaigns.complete
    [rumCounters.clientSuggestGroupsMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.groups,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.client.groups.complete
    [rumCounters.clientSuggestBannersMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.banners,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.client.banners.complete
    [rumCounters.clientSuggestPhraseMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.phrase,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.client.phrase.complete
    [rumCounters.clientSuggestTargetingsMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.targetings,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.client.targetings.complete
    [rumCounters.clientSuggestUsersProfileMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.client.users.profile.complete
    [rumCounters.clientSuggestMapperUnknown]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.phrase,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.client.unknown.complete
    [rumCounters.backendPhraseFeaturesData]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.phrase,
        blockStatDict.features,
        blockStatDict.data,
        blockStatDict.complete
    ), // dna.backend.phrase.features.data.complete
    [rumCounters.backendGetBanners]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.get,
        blockStatDict.banners,
        blockStatDict.complete
    ), // dna.backend.get.banners.complete
    [rumCounters.clientPhraseFeaturesDataMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.phrase,
        blockStatDict.features,
        blockStatDict.data,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.client.phrase.features.data.complete
    [rumCounters.backendGetGroupsMassActionsCount]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.get,
        blockStatDict.groups,
        blockStatDict.mass,
        blockStatDict.actions,
        blockStatDict.count
    ), // dna.backend.get.groups.mass.actions.count
    [rumCounters.clientGetBannersMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.get,
        blockStatDict.banners,
        blockStatDict.complete
    ), // dna.client.get.banners.complete
    [rumCounters.backendPriceWizardBids]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.price,
        blockStatDict.wizard,
        blockStatDict.bids,
        blockStatDict.complete
    ), // dna.backend.price.wizard.bids.complete
    [rumCounters.backendPriceWizardAutoBids]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.price,
        blockStatDict.dna,
        blockStatDict.auto,
        blockStatDict.bids,
        blockStatDict.complete
    ), // dna.backend.price.wizard.auto.bids.complete
    [rumCounters.backendSearchAndReplaceKeyWords]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.search,
        blockStatDict.and,
        blockStatDict.replace,
        blockStatDict.keywords,
        blockStatDict.complete
    ), // dna.backend.search.and.replace.keywords.complete,
    [rumCounters.backendSearchAndReplaceKeyWordsPreview]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.search,
        blockStatDict.and,
        blockStatDict.replace,
        blockStatDict.keywords,
        blockStatDict.preview,
        blockStatDict.complete
    ), // dna.backend.search.and.replace.keywords.preview.complete
    [rumCounters.backendKeywordsDelete]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.keywords,
        blockStatDict.delete,
        blockStatDict.complete
    ), // dna.backend.keywords.delete.complete
    [rumCounters.backendUnsuspendKeywords]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.unsuspend,
        blockStatDict.keywords,
        blockStatDict.complete
    ), // dna.backend.unsuspend.keywords.complete
    [rumCounters.backendSuspendKeywords]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.suspend,
        blockStatDict.keywords,
        blockStatDict.complete
    ), // dna.backend.suspend.keywords.complete
    [rumCounters.backendUpdateKeywords]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.update,
        blockStatDict.keywords,
        blockStatDict.complete
    ), // dna.backend.update.keywords.complete
    [rumCounters.backendAddKeywords]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.add,
        blockStatDict.keywords,
        blockStatDict.complete
    ), // dna.backend.add.keywords.complete
    [rumCounters.backendAddGroupMinusKeywords]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.add,
        blockStatDict.groups,
        blockStatDict.minus,
        blockStatDict.complete
    ), // dna.backend.add.group.minus.keywords.complete
    [rumCounters.backendMinusPhraseLibraryGrid]: getRumId(
        // TODO поправить
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.phrase
    ),
    [rumCounters.backendBulkUpdateOrganizations]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.organizations,
        blockStatDict.mass,
        blockStatDict.update
    ), // dna.backend.organizations.mass.update
    [rumCounters.backendRecommendations]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.recommendations,
        blockStatDict.complete
    ), // dna.backend.recommendations.complete
    [rumCounters.backendGridRecommendationsDailyBudget]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.grid,
        blockStatDict.daily,
        blockStatDict.budget,
        blockStatDict.recommendations,
        blockStatDict.complete
    ), // dna.backend.grid.recommendations.complete
    [rumCounters.backendGridRecommendationsRemovePagesFromBlackList]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.grid,
        blockStatDict.remove,
        blockStatDict.black,
        blockStatDict.list,
        blockStatDict.recommendations,
        blockStatDict.complete
    ),
    [rumCounters.backendGridRecommendationsSwitchOnAutotargeting]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.grid,
        blockStatDict.switch,
        blockStatDict.on,
        blockStatDict.auto,
        blockStatDict.targetings,
        blockStatDict.recommendations,
        blockStatDict.complete
    ), // dna.backend.grid.recommendations.complete
    [rumCounters.clientGridRecommendationsDailyBudgetMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.grid,
        blockStatDict.daily,
        blockStatDict.budget,
        blockStatDict.recommendations,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.backend.grid.recommendations.complete
    [rumCounters.clientGridRecommendationsRemovePagesFromBlackListMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.grid,
        blockStatDict.remove,
        blockStatDict.black,
        blockStatDict.list,
        blockStatDict.recommendations,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.backend.grid.recommendations.complete
    [rumCounters.clientGridRecommendationsSwitchOnAutotargetingMapper]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.grid,
        blockStatDict.switch,
        blockStatDict.on,
        blockStatDict.auto,
        blockStatDict.targetings,
        blockStatDict.recommendations,
        blockStatDict.mapper,
        blockStatDict.complete
    ), // dna.backend.grid.recommendations.complete
    [rumCounters.clientGridRecommendationsDailyBudgetRender]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.grid,
        blockStatDict.daily,
        blockStatDict.budget,
        blockStatDict.recommendations,
        blockStatDict.render,
        blockStatDict.complete
    ), // dna.client.grid.daily.budget.recommendations.render.complete
    [rumCounters.clientGridRecommendationsRemovePagesFromBlackListRender]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.grid,
        blockStatDict.remove,
        blockStatDict.black,
        blockStatDict.list,
        blockStatDict.recommendations,
        blockStatDict.render,
        blockStatDict.complete
    ), // dna.client.grid.remove.black.list.recommendations.render.complete
    [rumCounters.clientGridRecommendationsSwitchOnAutotargetingRender]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.grid,
        blockStatDict.switch,
        blockStatDict.on,
        blockStatDict.auto,
        blockStatDict.targetings,
        blockStatDict.recommendations,
        blockStatDict.render,
        blockStatDict.complete
    ), // dna.client.grid.switch.on.auto.targetings.recommendations.render.complete
    [rumCounters.clientRecommendationsRender]: getRumId(
        blockStatDict.dna,
        blockStatDict.client,
        blockStatDict.recommendations,
        blockStatDict.render,
        blockStatDict.complete
    ), // dna.client.recommendations.render.complete
    [rumCounters.dnaGridCampaignsRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.campaigns
    ),
    [rumCounters.dnaGridGroupsRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.groups
    ),
    [rumCounters.dnaGridBannersRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.banners
    ),
    [rumCounters.dnaGridPhrasesRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.grid,
        blockStatDict.phrases
    ),
    [rumCounters.dnaGridTargetingsRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.grid,
        blockStatDict.targetings
    ),
    [rumCounters.dnaGridUsersProfileRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.grid,
        blockStatDict.users,
        blockStatDict.profile
    ),
    [rumCounters.dnaLogsRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.logs
    ),
    [rumCounters.dnaRecommendationsGridRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.recommendations,
        blockStatDict.grid
    ),
    [rumCounters.dnaRecommendationsRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.recommendations
    ),
    [rumCounters.dnaOfflineReportsRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.offline,
        blockStatDict.reports
    ),
    [rumCounters.dnaCustomersRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.customers
    ),
    [rumCounters.dnaWelcomeRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.welcome
    ),
    [rumCounters.dnaMobileAppsRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.mobile,
        blockStatDict.apps
    ),
    [rumCounters.dnaFreelancersRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.freelancers
    ),
    [rumCounters.dnaDealsRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.deals
    ),
    [rumCounters.dnaBannersEditRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.banners,
        blockStatDict.edit
    ),
    [rumCounters.dnaGroupsEditRouteSubPage]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.route,
        blockStatDict.groups,
        blockStatDict.edit
    ),
    [rumCounters.dnaSPARecommendationsRender]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.recommendations
    ),
    [rumCounters.dnaSPABannersEditRender]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.banners,
        blockStatDict.edit
    ),
    [rumCounters.dnaSPABannersEditCpmRender]: getRumId(
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.cpm
    ),
    [rumCounters.dnaSPABannersEditCpcRender]: getRumId(
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.cpc
    ),
    [rumCounters.dnaSPABannersEditRender10]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.items
    ),
    [rumCounters.dnaSPABannersEditRender50]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.items
    ),
    [rumCounters.dnaSPABannersEditRender100]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.items
    ),
    [rumCounters.dnaSPABannersEditRender500]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.items
    ),
    [rumCounters.dnaSPABannersEditRender1000]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.banners,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.items
    ),
    [rumCounters.dnaSPAGroupsEditRender]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.groups,
        blockStatDict.edit
    ),
    [rumCounters.dnaSPAGroupsEditCpmRender]: getRumId(
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.cpm
    ),
    [rumCounters.dnaSPAGroupsEditCpcRender]: getRumId(
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.cpc
    ),
    [rumCounters.dnaSPAGroupsEditRender10]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.ten,
        blockStatDict.items
    ),
    [rumCounters.dnaSPAGroupsEditRender50]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.fifty,
        blockStatDict.items
    ),
    [rumCounters.dnaSPAGroupsEditRender100]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.hundred,
        blockStatDict.items
    ),
    [rumCounters.dnaSPAGroupsEditRender500]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.five,
        blockStatDict.hundred,
        blockStatDict.items
    ),
    [rumCounters.dnaSPAGroupsEditRender1000]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.groups,
        blockStatDict.edit,
        blockStatDict.complete,
        blockStatDict.thousand,
        blockStatDict.items
    ),
    [rumCounters.dnaSPARecommendationsGridRender]: getRumId(
        blockStatDict.ru,
        blockStatDict.direct,
        blockStatDict.dna,
        blockStatDict.spa,
        blockStatDict.route,
        blockStatDict.recommendations,
        blockStatDict.grid
    ),
    [campaigns]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.campaigns,
        blockStatDict.render
    ), // dna.view.campaigns.render
    [groups]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.groups,
        blockStatDict.render
    ), // dna.view.groups.render
    [banners]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.banners,
        blockStatDict.render
    ), // dna.view.banners.render
    [phrases]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.phrase,
        blockStatDict.render
    ), // dna.view.phrase.render
    [retargetings]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.targetings,
        blockStatDict.render
    ), // dna.view.targetings.render
    [feedFilters]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.feed,
        blockStatDict.filters,
        blockStatDict.render
    ), // dna.view.feed.filters.render
    [usersProfile]: getRumId(
        blockStatDict.dna,
        blockStatDict.view,
        blockStatDict.users,
        blockStatDict.profile,
        blockStatDict.render
    ), // dna.view.users.profile.render
    [rumCounters.backendCampaignRecommendations]: getRumId(
        blockStatDict.dna,
        blockStatDict.backend,
        blockStatDict.campaign,
        blockStatDict.recommendations
    )
};

export class RUM {
    static isDataActual = RUM.getDataRelevanceState();

    static isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
    );

    static firstLoadShipped: boolean;

    static timerDict: Partial<Record<RumCountersDictKeys, number>> = {};

    static apiManager: RestApiManager;

    static init(): void {
        document.addEventListener('visibilitychange', () => {
            RUM.isDataActual = RUM.getDataRelevanceState();
        });
    }

    public static isPageVisible(): boolean {
        return document.visibilityState === 'visible';
    }

    // Отправка TTI страниц при первой загрузке приложения
    public static sendTTIData(): void {
        if (window.Ya && Ya.Rum) {
            const isGrid = /dna\/grid/.test(location.pathname),
                isLogs = /dna\/log/.test(location.pathname),
                isRecommendationGrid = /dna\/recommendations-grid/.test(
                    location.pathname
                ),
                isRecommendation = /dna\/recommendations$/.test(
                    location.pathname
                ),
                isOfflineReports = /dna\/offline-reports/.test(
                    location.pathname
                ),
                isCustomers = /dna\/customers/.test(location.pathname),
                isWelcome = /dna\/welcome/.test(location.pathname),
                isMobileApps = /dna\/mobile-apps/.test(location.pathname),
                isFreelancers = /dna\/freelancers/.test(location.pathname),
                isDeals = /dna\/deals/.test(location.pathname),
                isBannersEdit = /dna\/banners-edit/.test(location.pathname),
                isGroupsEdit = /dna\/groups-edit/.test(location.pathname);

            if (isGrid) {
                const dnaPageByView = {
                        campaigns:
                            rumCountersDict[
                                rumCounters.dnaGridCampaignsRouteSubPage
                            ],
                        groups:
                            rumCountersDict[
                                rumCounters.dnaGridGroupsRouteSubPage
                            ],
                        banners:
                            rumCountersDict[
                                rumCounters.dnaGridBannersRouteSubPage
                            ],
                        phrases:
                            rumCountersDict[
                                rumCounters.dnaGridPhrasesRouteSubPage
                            ],
                        retargetings:
                            rumCountersDict[
                                rumCounters.dnaGridTargetingsRouteSubPage
                            ],
                        usersProfile:
                            rumCountersDict[
                                rumCounters.dnaGridUsersProfileRouteSubPage
                            ]
                    },
                    pathMatch = location.pathname.match(/\/dna\/grid\/(\w+)/),
                    view = pathMatch ? pathMatch[1] : 'campaigns',
                    subPage = Ya.Rum.makeSubPage(dnaPageByView[view]);

                Ya.Rum.sendTTI(false, 0, subPage);
            }

            if (isLogs) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[rumCounters.dnaLogsRouteSubPage]
                    )
                );
            }

            if (isRecommendationGrid) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[
                            rumCounters.dnaRecommendationsGridRouteSubPage
                        ]
                    )
                );
            }

            if (isRecommendation) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[
                            rumCounters.dnaRecommendationsRouteSubPage
                        ]
                    )
                );
            }

            if (isOfflineReports) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[
                            rumCounters.dnaOfflineReportsRouteSubPage
                        ]
                    )
                );
            }

            if (isCustomers) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[rumCounters.dnaCustomersRouteSubPage]
                    )
                );
            }

            if (isWelcome) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[rumCounters.dnaWelcomeRouteSubPage]
                    )
                );
            }

            if (isMobileApps) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[rumCounters.dnaMobileAppsRouteSubPage]
                    )
                );
            }

            if (isFreelancers) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[rumCounters.dnaFreelancersRouteSubPage]
                    )
                );
            }

            if (isDeals) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[rumCounters.dnaDealsRouteSubPage]
                    )
                );
            }

            if (isBannersEdit) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[rumCounters.dnaBannersEditRouteSubPage]
                    )
                );
            }

            if (isGroupsEdit) {
                Ya.Rum.sendTTI(
                    false,
                    0,
                    Ya.Rum.makeSubPage(
                        rumCountersDict[rumCounters.dnaGroupsEditRouteSubPage]
                    )
                );
            }
        }
    }

    public static getBackendLoadKey(key: RumCountersBackendKeys): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.backendCampaigns; // .backend.complete
            case groups:
                return rumCounters.backendGroups; // .backend.complete
            case banners:
                return rumCounters.backendBanners; // .backend.complete
            case phrases:
                return rumCounters.backendPhrase; // .backend.complete
            case retargetings:
                return rumCounters.backendTargetings; // .backend.complete
            case usersProfile:
                return rumCounters.backendUsersProfile; // .backend.complete
            default:
                return rumCounters.backendUnknown; // .backend.complete
        }
    }

    public static getClientMapperLoadKey(
        key: RumCountersBackendKeys
    ): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.clientCampaignsMapper; // .client.complete
            case groups:
                return rumCounters.clientGroupsMapper; // .client.complete
            case banners:
                return rumCounters.clientBannersMapper; // .client.complete
            case phrases:
                return rumCounters.clientPhraseMapper; // .client.complete
            case retargetings:
                return rumCounters.clientTargetingsMapper; // .client.complete
            case usersProfile:
                return rumCounters.clientUsersProfileMapper; // .client.complete
            default:
                return rumCounters.clientMapperUnknown; // .client.complete
        }
    }

    public static getBackendSuggestLoadKey(
        key: RumCountersBackendKeys
    ): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.backendSuggestCampaigns; // .backend.complete
            case groups:
                return rumCounters.backendSuggestGroups; // .backend.complete
            case banners:
                return rumCounters.backendSuggestBanners; // .backend.complete
            case phrases:
                return rumCounters.backendSuggestPhrase; // .backend.complete
            case retargetings:
                return rumCounters.backendSuggestTargetings; // .backend.complete
            case usersProfile:
                return rumCounters.backendSuggestUsersProfile; // .backend.complete
            default:
                return rumCounters.backendSuggestUnknown; // .backend.complete
        }
    }

    public static getClientMapperSuggestLoadKey(
        key: RumCountersBackendKeys
    ): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.clientSuggestCampaignsMapper; // .client.complete
            case groups:
                return rumCounters.clientSuggestGroupsMapper; // .client.complete
            case banners:
                return rumCounters.clientSuggestBannersMapper; // .client.complete
            case phrases:
                return rumCounters.clientSuggestPhraseMapper; // .client.complete
            case retargetings:
                return rumCounters.clientSuggestTargetingsMapper; // .client.complete
            case usersProfile:
                return rumCounters.clientSuggestUsersProfileMapper; // .client.complete
            default:
                return rumCounters.clientSuggestMapperUnknown; // .client.complete
        }
    }

    public static getFirstLoadKeyByView(key?: string | null): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.campaignsFirst; // .first.load
            case groups:
                return rumCounters.groupsFirst; // .first.load
            case banners:
                return rumCounters.bannersFirst; // .first.load
            case phrases:
                return rumCounters.phrasesFirst; // .first.load
            case audiences:
                return rumCounters.audiencesFirst; // .first.load
            case retargetings:
                return rumCounters.targetingsFirst; // .first.load
            case usersProfile:
                return rumCounters.usersProfileFirst; // .first.load
            case feedFilters:
                return rumCounters.feedFiltersFirst; // .first.load
            default:
                return rumCounters.unknownFisrt; // .first.load
        }
    }

    public static getFirstLoadKeyByViewLessThenTenItems(
        key?: string | null
    ): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.campaignsFirst10; // .complete.ten.grid.items
            case groups:
                return rumCounters.groupsFirst10; // .complete.ten.grid.items
            case banners:
                return rumCounters.bannersFirst10; // .complete.ten.grid.items
            case phrases:
                return rumCounters.phrasesFirst10; // .complete.ten.grid.items
            case audiences:
                return rumCounters.audiencesFirst10; // .complete.ten.grid.items
            case retargetings:
                return rumCounters.targetingsFirst10; // .complete.ten.grid.items
            case usersProfile:
                return rumCounters.usersProfileFirst10; // .complete.ten.grid.items
            case feedFilters:
                return rumCounters.feedFiltersFirst10; // .complete.ten.grid.items
            default:
                return rumCounters.unknownFisrt; // .complete.ten.grid.items
        }
    }

    public static getFirstLoadKeyByViewLessThenFiftyItems(
        key?: string | null
    ): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.campaignsFirst50; // .complete.fifty.grid.items
            case groups:
                return rumCounters.groupsFirst50; // .complete.fifty.grid.items
            case banners:
                return rumCounters.bannersFirst50; // .complete.fifty.grid.items
            case phrases:
                return rumCounters.phrasesFirst50; // .complete.fifty.grid.items
            case audiences:
                return rumCounters.audiencesFirst50; // .complete.fifty.grid.items
            case retargetings:
                return rumCounters.targetingsFirst50; // .complete.fifty.grid.items
            case usersProfile:
                return rumCounters.usersProfileFirst50; // .complete.fifty.grid.items
            case feedFilters:
                return rumCounters.feedFiltersFirst50; // .complete.fifty.grid.items
            default:
                return rumCounters.unknownFisrt; // .complete.fifty.grid.items
        }
    }

    public static getFirstLoadKeyByViewLessThenHundredItems(
        key?: string | null
    ): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.campaignsFirst100; // .complete.hundred.grid.items
            case groups:
                return rumCounters.groupsFirst100; // .complete.hundred.grid.items
            case banners:
                return rumCounters.bannersFirst100; // .complete.hundred.grid.items
            case phrases:
                return rumCounters.phrasesFirst100; // .complete.hundred.grid.items
            case audiences:
                return rumCounters.audiencesFirst100; // .complete.hundred.grid.items
            case retargetings:
                return rumCounters.targetingsFirst100; // .complete.hundred.grid.items
            case usersProfile:
                return rumCounters.usersProfileFirst100; // .complete.hundred.grid.items
            case feedFilters:
                return rumCounters.feedFiltersFirst100; // .complete.hundred.grid.items
            default:
                return rumCounters.unknownFisrt; // .complete.fifty.grid.items
        }
    }

    public static getFirstLoadKeyByViewLessThenFiveHundredItems(
        key?: string | null
    ): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.campaignsFirst500; // .complete.five.hundred.grid.items
            case groups:
                return rumCounters.groupsFirst500; // .complete.five.hundred.grid.items
            case banners:
                return rumCounters.bannersFirst500; // .complete.five.hundred.grid.items
            case phrases:
                return rumCounters.phrasesFirst500; // .complete.five.hundred.grid.items
            case audiences:
                return rumCounters.audiencesFirst500; // .complete.five.hundred.grid.items
            case retargetings:
                return rumCounters.targetingsFirst500; // .complete.five.hundred.grid.items
            case usersProfile:
                return rumCounters.usersProfileFirst500; // .complete.five.hundred.grid.items
            case feedFilters:
                return rumCounters.feedFiltersFirst500; // .complete.five.hundred.grid.items
            default:
                return rumCounters.unknownFisrt; // .complete.fifty.grid.items
        }
    }

    public static getFirstLoadKeyByViewLessThenThousandItems(
        key?: string | null
    ): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.campaignsFirst1000; // .complete.thousand.grid.items
            case groups:
                return rumCounters.groupsFirst1000; // .complete.thousand.grid.items
            case banners:
                return rumCounters.bannersFirst1000; // .complete.thousand.grid.items
            case phrases:
                return rumCounters.phrasesFirst1000; // .complete.thousand.grid.items
            case audiences:
                return rumCounters.audiencesFirst1000; // .complete.thousand.grid.items
            case retargetings:
                return rumCounters.targetingsFirst1000; // .complete.thousand.grid.items
            case usersProfile:
                return rumCounters.usersProfileFirst1000; // .complete.thousand.grid.items
            case feedFilters:
                return rumCounters.feedFiltersFirst1000; // .complete.thousand.grid.items
            default:
                return rumCounters.unknownFisrt; // .complete.fifty.grid.items
        }
    }

    public static getFirstLoadKeyByViewLessThenTenThousandItems(
        key?: string | null
    ): rumCounters {
        switch (key) {
            case campaigns:
                return rumCounters.campaignsFirst10000; // .complete.ten.thousand.grid.items
            case groups:
                return rumCounters.groupsFirst10000; // .complete.ten.thousand.grid.items
            case banners:
                return rumCounters.bannersFirst10000; // .complete.ten.thousand.grid.items
            case phrases:
                return rumCounters.phrasesFirst10000; // .complete.ten.thousand.grid.items
            case audiences:
                return rumCounters.audiencesFirst10000; // .complete.ten.thousand.grid.items
            case retargetings:
                return rumCounters.targetingsFirst10000; // .complete.ten.thousand.grid.items
            case usersProfile:
                return rumCounters.usersProfileFirst10000; // .complete.ten.thousand.grid.items
            case feedFilters:
                return rumCounters.feedFiltersFirst10000; // .complete.ten.thousand.grid.items
            default:
                return rumCounters.unknownFisrt; // .complete.fifty.grid.items
        }
    }

    public static getFirstLoadKeyByRoute(
        key?: string,
        additionalParams?: string
    ): rumCounters | undefined {
        switch (key) {
            case RoutesPath.recommendationsItems:
                switch (additionalParams) {
                    case recommendationTypeParam.dailyBudget:
                        return rumCounters.clientGridRecommendationsDailyBudgetRender;
                    case recommendationTypeParam.switchOnAutotargeting:
                        return rumCounters.clientGridRecommendationsSwitchOnAutotargetingRender;
                    case recommendationTypeParam.removePagesFromBlackList:
                        return rumCounters.clientGridRecommendationsRemovePagesFromBlackListRender;
                    default:
                        return;
                }

            case RoutesPath.recommendationsPage:
                return rumCounters.clientRecommendationsRender;
            default:
                return;
        }
    }

    public static startViewTimer(
        keyForTrencher: RumCountersDictKeys,
        keysForGrafana: RumCountersDictKeys[]
    ): void {
        if (RUM.isRumInited()) {
            Ya.Rum.time(rumCountersDict[keyForTrencher]);
        }

        if (Object.keys(RUM.timerDict).length === 0 && RUM.firstLoadShipped) {
            RUM.isDataActual = RUM.getDataRelevanceState();
        }

        const startTime = RUM.getTime();

        keysForGrafana.forEach(key => {
            RUM.timerDict[key] = startTime;
        });
    }

    public static getTime(): number {
        if (RUM.isRumInited()) {
            return Ya.Rum.getTime();
        } else {
            return Date.now();
        }
    }

    public static endTimer(
        keyForTrencher: RumCountersDictKeys,
        keysForGrafana: RumCountersDictKeys[],
        reqId?: string
    ): void {
        if (RUM.isRumInited()) {
            Ya.Rum.timeEnd(rumCountersDict[keyForTrencher]);
        }

        const endTime = RUM.getTime();

        const data = keysForGrafana.reduce((res, key) => {
            const startTime = RUM.timerDict[key];

            if (startTime !== undefined) {
                res = {
                    ...res,
                    [key]: endTime - startTime
                };
            }

            delete RUM.timerDict[key];

            return res;
        }, {});

        if (Object.keys(data).length !== 0) {
            RUM.reportForGraphite(data, reqId);
        }
    }

    // Функция замеры дельты времени(конец минус начало);
    public static reportAsyncDelta<T>(
        key: RumCountersDictKeys,
        fn: () => Promise<{ result: T; reqId?: string }>
    ): Promise<T> {
        RUM.startViewTimer(key, [key]);

        return fn().then(({ result, reqId }) => {
            RUM.endTimer(key, [key], reqId);

            return result;
        });
    }

    public static reportSyncDelta<T>(
        key: RumCountersDictKeys,
        reqId: string,
        fn: () => T
    ): T {
        RUM.startViewTimer(key, [key]);

        const data = fn();

        RUM.endTimer(key, [key], reqId);

        return data;
    }

    public static registerApiManager(apiManager: RestApiManager): void {
        RUM.apiManager = apiManager;
    }

    public static sendFirstLoadTime(
        keyForTrencher: RumCountersDictKeys,
        keysForGrafana: RumCountersDictKeys[],
        reqId?: string
    ): void {
        const firstLoad = Ya.Rum.getTime();

        if (RUM.isRumInited()) {
            Ya.Rum.sendTimeMark(rumCountersDict[keyForTrencher], firstLoad);
        }

        RUM.reportForGraphite(
            keysForGrafana.reduce((res, key) => {
                return {
                    ...res,
                    [key]: firstLoad
                };
            }, {}),
            reqId
        );

        RUM.firstLoadShipped = true;
    }

    public static reportIfFailedToInit(
        login: string,
        perlReqId?: string
    ): void {
        if (!RUM.isRumInited()) {
            captureException(new Error('Rum failed to initialize'), {
                extra: { login, perlReqId }
            });
        }
    }

    public static isRumInited(): boolean {
        if (window.Ya && Ya.Rum) {
            return true;
        } else {
            return false;
        }
    }

    private static reportForGraphite(
        data: Partial<Record<RumCountersDictKeys, number>>,
        reqId?: string
    ): void {
        if (RUM.apiManager) {
            RUM.apiManager.sendToGraffit(
                data,
                {
                    isDataActual: RUM.isDataActual
                },
                RUM.isMobile ? DeviceType.mobile : DeviceType.desktop,
                reqId
            );
        }
    }

    private static getDataRelevanceState(): boolean {
        return document.visibilityState === 'visible';
    }
}
